document.addEventListener('DOMContentLoaded', () => {
    let consentInitialized = false;
    let consentGiven = false;

    // Basic check to prevent duplicate initialization
    if (document.querySelector('.cookie-consent-container')) return;

    const cookieHTML = `
        <div class="cookie-consent-container minimized">
            <h2>We value your privacy</h2>
            <p>
                We use cookies to enhance your authentication experience and to save your preferences. By clicking “Accept” you consent to our use of cookies. 
                <a href="privacy.html">Cookie Policy</a>
            </p>
            <div class="cookie-consent-actions">
                <button class="cookie-consent-btn decline" id="cookie-decline">Decline</button>
                <button class="cookie-consent-btn blue-button" id="blue-button">Accept</button>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', cookieHTML);

    const container = document.querySelector('.cookie-consent-container');
    const btnDecline = document.getElementById('cookie-decline');
    const btnAccept = document.getElementById('blue-button');


    const showConsent = (e) => {
        if (e) e.stopPropagation();
        container.classList.remove('minimized');
    };
    const closeConsent = (e) => {
        if (e) e.stopPropagation();
        container.classList.add('minimized');
    };

    const handleAccept = (e) => {
        if (__LOG_INFO__) AppLog.info('cookieconsent', window.cookieconsent,  window.cookieConsentInstance)
        if (window.cookieConsentInstance) window.cookieConsentInstance.setStatus('allow');
        closeConsent(e);
    };

    const handleDecline = (e) => {
        if (__LOG_INFO__) AppLog.info('cookieconsent', window.cookieconsent,  window.cookieConsentInstance)
        if (window.cookieConsentInstance) window.cookieConsentInstance.setStatus('deny');
        closeConsent(e);
    };

    container.addEventListener('click', () => {
        if (container.classList.contains('minimized')) {
            container.classList.remove('minimized');
        }
    });

    if (btnDecline) btnDecline.addEventListener('click', handleDecline);
    if (btnAccept) btnAccept.addEventListener('click', handleAccept);
});
